import jsPDF from "jspdf";
import { font, fontBold } from "@/assets/fonts/Sarabun-normal.js";

export default {
  methods: {
    async generatePdf() {
      try {
        this.localBtnDisabled = true;

        const startDate = this.start
          ? this.start
          : this.moment().startOf("month").format("YYYY-MM-DD");

        const endDate = this.end
          ? this.end
          : this.moment().format("YYYY-MM-DD");

        console.log(startDate, endDate);
        // await this.getMember();
        let pdf = new jsPDF(this.pdfOption);

        // const margin_l = this.pdfConfig.margin.l;
        const margin_t = this.pdfConfig.margin.t;
        // =========================
        // GLOBAL MARGIN
        // =========================
        const PAGE_MARGIN_X = 15;
        const PAGE_MARGIN_TOP = 2;
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const marginX = 10;
        // const marginTop = 5;

        let pdf_position_y = PAGE_MARGIN_TOP;

        const addNewPageIfNeeded = (incrementValue) => {
          if (pdf_position_y + incrementValue >= pdfHeight - margin_t) {
            pdf.addPage();
            pdf_position_y = margin_t; // Reset the position to the top of the new page
          } else {
            pdf_position_y += incrementValue; // Add the input value
          }
        };

        pdf.addFileToVFS("Sarabun-Regular.ttf", fontBold);
        pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "bold");
        pdf.addFileToVFS("Sarabun-Regular.ttf", font);
        pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "normal");

        pdf.setFont("Sarabun", "bold");

        pdf.setFontSize(this.pdfConfig.typo.header);
        pdf_position_y += margin_t;
        pdf.text(
          "รายงานการยกเลิก",
          pdfWidth / 2,
          pdf_position_y,
          null,
          null,
          "center",
        );

        addNewPageIfNeeded(this.pdfConfig.endRow);
        pdf.setFont("Sarabun", "normal");

        pdf.setFontSize(this.pdfConfig.typo.extraSmall);
        this.thaitext(
          pdf,
          "ข้อมูลวันที่ : " +
            this.formatDateToThaiShort(
              startDate
            ) +
            " - " +
            this.formatDateToThaiShort(
              endDate
            ),
          pdfWidth - 15,
          pdf_position_y,
          0,
          "right"
        );

        addNewPageIfNeeded(this.pdfConfig.endRow);
        pdf.setFontSize(this.pdfConfig.typo.small);

        this.thaitext(
          pdf,
          "สถาบัน : " + this.comName,
          PAGE_MARGIN_X,
          pdf_position_y,
        );

        addNewPageIfNeeded(this.pdfConfig.endNormal);

        this.thaitext(
          pdf,
          "รวม : " + (this.cancelInfo?.data?.length || 0) + " รายการ",
          PAGE_MARGIN_X,
          pdf_position_y,
        );

        addNewPageIfNeeded(this.pdfConfig.endNormal);

        // pdf_position_y = pdf_position_y + marginTop;
        //table 1
        // ===== TABLE CONFIG =====
        const columns = [
          { key: "column1", title: "วันที่ทำรายการ", ratio: 1.0 },
          { key: "column2", title: "วันที่ยกเลิก", ratio: 1.0 },
          { key: "column3", title: "รหัสนักเรียน", ratio: 1.2 },
          { key: "column4", title: "เลขอ้างอิง", ratio: 1.2 },
          { key: "column5", title: "ชื่อนักเรียน", ratio: 1.4 },
          { key: "column6", title: "ดำเนินการโดย", ratio: 1.3 },
          { key: "column7", title: "จำนวน(บาท)", ratio: 1.1 },
          { key: "column8", title: "ช่องทาง", ratio: 1.5 },
          { key: "column9", title: "รายการ", ratio: 1.6 },
          { key: "column10", title: "สาเหตุ", ratio: 1.4 },
          { key: "column11", title: "รายละเอียด", ratio: 1.6 },
        ];

        // =========================
        // AUTO WIDTH
        // =========================
        const totalRatio = columns.reduce((sum, col) => sum + col.ratio, 0);

        const tableWidth = pdfWidth - marginX * 2;

        columns.forEach((col) => {
          col.width = (col.ratio / totalRatio) * tableWidth;
        });

        // =========================
        // TABLE DATA
        // =========================
        const table1Data = this.cancelInfo?.data?.map((item) => ({
          column1: item.purchaseDate
            ? new Date(item.purchaseDate).toLocaleDateString("en-GB")
            : "-",
          column2: item.canceledAt
            ? new Date(item.canceledAt).toLocaleDateString("en-GB")
            : "-",
          column3: item.studentId || "-",
          column4: item.orderNumber || "-",
          column5: `${item.ownerFirstName || ""} ${item.ownerLastName ||
            ""}`.trim(),
          column6:
            item.firstName || item.lastName
              ? `${item.firstName || ""} ${item.lastName || ""}`.trim()
              : item.cancelRemark == "ORDER_EXPIRED_CANCELED_BY_SYSTEM"
              ? "ระบบ"
              : "-",
          column7: item.purchasePrice
            ? Number(item.purchasePrice).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "0.00",
          column8: {
            CREDITCARD: "บัตรเครดิต/บัตรเดบิต",
            TRANSFER: "ธนาคารกรุงไทย",
            ONLINEBANKING: "Mobile Banking",
            CASH: "เงินสด",
          }[item.paymentMethod] || "-",

          // รวม courseName หลาย item ขึ้นบรรทัดใหม่
          column9:
            item.items && item.items.length
              ? item.items.map((course) => course.courseName).join("\n")
              : "-",

          column10:
            item.cancelRemark == "ORDER_EXPIRED_CANCELED_BY_SYSTEM"
              ? "เกินกำหนดชำระเงิน"
              : item.refundReason || "-",

          column11: item.refundDescription || "-",
        }));

        // =========================
        // DRAW HEADER
        // =========================
        const HEADER_HEIGHT = 18;
        const HEADER_PADDING_TOP = 11;
        const drawHeader = () => {
          let currentX = PAGE_MARGIN_X;

          pdf.setFont("Sarabun", "bold");
          pdf.setFontSize(this.pdfConfig.typo.extraSmall);

          columns.forEach((col) => {
            pdf.setFillColor(230, 230, 230);

            pdf.rect(currentX, pdf_position_y, col.width, HEADER_HEIGHT);

            this.thaitext(
              pdf,
              col.title,
              currentX + col.width / 2 - pdf.getTextWidth(col.title) / 2,
              pdf_position_y + HEADER_PADDING_TOP,
            );

            currentX += col.width;
          });

          pdf_position_y += HEADER_HEIGHT;
        };

        drawHeader();

        // =========================
        // DRAW BODY
        // =========================
        pdf.setFont("Sarabun", "normal");
        pdf.setFontSize(this.pdfConfig.typo.extraSmall);

        const paddingX = 2;
        const paddingTop = 8;
        const paddingBottom = 0;
        const lineHeight = 8;

        table1Data.forEach((row) => {
          let currentX = PAGE_MARGIN_X;

          // =========================
          // calculate row height
          // =========================
          let maxLines = 1;

          columns.forEach((col) => {
            const text = String(row[col.key] || "");

            const lines = pdf.splitTextToSize(text, col.width - paddingX * 2);

            maxLines = Math.max(maxLines, lines.length);
          });

          const rowHeight = maxLines * lineHeight + paddingTop + paddingBottom;

          // =========================
          // page break
          // =========================
          if (pdf_position_y + rowHeight >= pdfHeight - PAGE_MARGIN_TOP) {
            pdf.addPage();

            pdf_position_y = PAGE_MARGIN_TOP;

            drawHeader();
            pdf.setFont("Sarabun", "normal");
            pdf.setFontSize(8);
          }

          // =========================
          // draw row
          // =========================
          columns.forEach((col) => {
            const text = String(row[col.key] || "");

            const lines = pdf.splitTextToSize(text, col.width - paddingX * 2);

            // border
            pdf.rect(currentX, pdf_position_y, col.width, rowHeight);

            // multiline text
            lines.forEach((line, index) => {
              this.thaitext(
                pdf,
                line,
                currentX + paddingX,
                pdf_position_y + paddingTop + index * lineHeight,
                {
                  align: "left",
                },
              );
            });

            currentX += col.width;
          });

          pdf_position_y += rowHeight;
        });

        addNewPageIfNeeded(this.pdfConfig.endRow);

        pdf.setDrawColor(0, 0, 0);

        setTimeout(() => {
          pdf.save("รายงานการยกเลิก.pdf");
        }, 0);
        this.localBtnDisabled = false;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
